import VDashboard from '@/views/dashboard/VDashboard'
import VDashboardAccount from '@/views/dashboard/VDashboardAccount'
import VDashboardBankAccount from '@/views/dashboard/VDashboardBankAccount'
import VDashboardIntroduction from '@/views/dashboard/VDashboardIntroduction'
import VDashboardPersonalData from '@/views/dashboard/VDashboardPersonalData'
import VLogin from '@/views/VLogin'
import VPageNotFound from '@/views/VPageNotFound'
import VProcess from '@/views/process/VProcess'
import VProcessFormRenderer from '@/views/process/VProcessFormRenderer'
import VProcessIntroduction from '@/views/process/VProcessIntroduction'
import VProcessRating from '@/views/process/VProcessRating'
import VProcessRatingList from '@/views/process/VProcessRatingList'
import VProject from '@/views/project/VProject'
import VProjectEdit from '@/views/project/VProjectEdit'
import VProjectIntroduction from '@/views/project/VProjectIntroduction'
import VProjectProposal from '@/views/project/VProjectProposal'
import VProjectRating from '@/views/project/VProjectRating'
import VProjectRatingList from '@/views/project/VProjectRatingList'
import VProjectSuggest from '@/views/project/VProjectSuggest'
import VChangePassword from '@/views/VChangePassword'
import VPasswordChangeSuccess from '@/views/VPasswordChangeSuccess'
import VResetPassword from '@/views/VResetPassword'
import VSelectRole from '@/views/VSelectRole'
import VSetPassword from '@/views/VSetPassword'
import VSignup from '@/views/VSignup'
import VUnverified from '@/views/VUnverified'
import VVerify from '@/views/VVerify'

import config from '@/config'

export default [
  {
    path: '/',
    name: 'index',
    redirect: { name: 'dashboard' }
  },
  {
    path: '/registrierung/:token?',
    name: 'signup',
    component: VSignup,
    props: route => ({
      token: route.params.token
    }),
    meta: {
      title: 'Registrierung',
      permission: {
        public: true
      }
    }
  },
  {
    path: '/login/:token?',
    name: 'login',
    component: VLogin,
    props: route => ({
      token: route.params.token
    }),
    meta: {
      title: 'Login',
      permission: {
        public: true
      }
    }
  },
  {
    path: '/passwort-vergessen',
    name: 'reset-password',
    component: VResetPassword,
    meta: {
      title: 'Passwort vergessen',
      permission: {
        public: true
      }
    }
  },
  {
    path: '/passwort-setzen/:identifier',
    name: 'set-password',
    component: VSetPassword,
    props: route => ({
      identifier: route.params.identifier
    }),
    meta: {
      title: 'Neues Passwort setzen',
      permission: {
        public: true
      }
    }
  },
  {
    path: '/passwort-aendern',
    name: 'change-password',
    component: VChangePassword,
    meta: {
      title: 'Passwort ändern'
    }
  },
  {
    path: '/passwort-erfolgreich-geaendert',
    name: 'password-change-success',
    component: VPasswordChangeSuccess,
    meta: {
      title: 'Passwort erfolgreich geändert'
    }
  },
  {
    path: '/nicht-verifiziert',
    name: 'unverified-account',
    component: VUnverified,
    meta: {
      title: 'E-Mail-Adresse noch nicht bestätigt',
      permission: {
        public: true
      }
    }
  },
  {
    path: '/verifizieren/:identifier',
    name: 'verify-account',
    component: VVerify,
    props: route => ({
      identifier: route.params.identifier
    }),
    meta: {
      title: 'E-Mail-Adresse bestätigen',
      permission: {
        public: true
      }
    }
  },
  {
    path: '/neues-programm',
    name: 'select-role',
    component: VSelectRole,
    meta: {
      title: 'Was möchten Sie tun?'
    }
  },
  {
    path: '/dashboard',
    component: VDashboard,
    meta: {
      title: 'Dashboard'
    },
    children: [
      {
        path: '/',
        name: 'dashboard',
        component: VDashboardIntroduction
      },
      {
        path: 'konto',
        name: 'dashboard-account',
        component: VDashboardAccount,
        meta: {
          title: 'Konto'
        }
      },
      {
        path: 'persoenliche-daten',
        name: 'dashboard-personal-data',
        component: VDashboardPersonalData,
        meta: {
          title: 'Persönliche Daten',
          permission: {
            group: ['applicant']
          }
        }
      },
      {
        path: 'bankverbindung',
        name: 'dashboard-bank-account',
        component: VDashboardBankAccount,
        meta: {
          title: 'Bankverbindung',
          permission: {
            group: ['applicant']
          }
        }
      }
    ]
  },
  {
    path: '/foerderprogramm',
    component: VProcess,
    meta: {
      title: 'Förderprogramm'
    },
    children: [
      {
        path: '/',
        name: 'process',
        component: VProcessIntroduction,
        meta: {
          permission: {
            group: ['applicant']
          }
        }
      },
      {
        path: ':identifier/bearbeiten',
        name: 'process-edit',
        component: VProcessFormRenderer,
        props: route => ({
          identifier: route.params.identifier
        }),
        meta: {
          title: 'Bewerbung bearbeiten',
          permission: {
            group: ['applicant']
          }
        }
      },
      {
        path: ':identifier/bewertungen',
        name: 'process-rating-list',
        component: VProcessRatingList,
        props: route => ({
          identifier: route.params.identifier
        }),
        meta: {
          title: 'Bewertungen',
          permission: {
            group: ['applicant', 'css_supervisor', 'professor']
          }
        }
      },
      {
        path: ':identifier/bewerten/:period',
        name: 'process-rating-add',
        component: VProcessRating,
        props: route => ({
          identifier: route.params.identifier,
          period: route.params.period
        }),
        meta: {
          title: 'Bewerten',
          permission: {
            group: ['applicant', 'professor']
          }
        }
      }
    ]
  },
  {
    path: '/projekt',
    component: VProject,
    meta: {
      title: 'Projekt'
    },
    children: [
      {
        path: '/',
        name: 'project',
        component: VProjectIntroduction,
        meta: {
          permission: {
            group: ['professor', 'teacher']
          }
        }
      },
      {
        path: 'lehrer-vorschlagen',
        name: 'project-suggest-teacher',
        component: VProjectSuggest,
        props: {
          type: config.project.type.SCHOOL
        },
        meta: {
          title: 'Lehrer vorschlagen',
          permission: {
            group: ['pupil']
          }
        }
      },
      {
        path: 'professor-vorschlagen',
        name: 'project-suggest-professor',
        component: VProjectSuggest,
        props: {
          type: config.project.type.UNIVERSITY
        },
        meta: {
          title: 'Professor vorschlagen',
          permission: {
            group: ['student']
          }
        }
      },
      {
        path: 'vorschlagen',
        name: 'project-proposal',
        component: VProjectProposal,
        meta: {
          title: 'Vorschlagen',
          permission: {
            group: ['teacher', 'professor']
          }
        }
      },
      {
        path: 'bearbeiten/:identifier',
        name: 'project-edit',
        component: VProjectEdit,
        props: route => ({
          identifier: route.params.identifier
        }),
        meta: {
          title: 'Bearbeiten',
          permission: {
            group: ['teacher', 'professor']
          }
        }
      },
      {
        path: 'bewerten/:ratingCode',
        name: 'project-rating',
        component: VProjectRating,
        props: route => ({
          ratingCode: route.params.ratingCode
        }),
        meta: {
          title: 'Bewerten',
          permission: {
            group: ['student', 'pupil']
          }
        }
      },
      {
        path: 'bewertungen/:identifier',
        name: 'project-rating-list',
        component: VProjectRatingList,
        props: route => ({
          identifier: route.params.identifier
        }),
        meta: {
          title: 'Bewertungen',
          permission: {
            group: ['professor', 'css_supervisor', 'teacher']
          }
        }
      }
    ]
  },
  {
    path: '*',
    component: VPageNotFound
  }
]
